import { CuboidVariants } from '@abyss/3d-viewer';
import { DEFAULT_CUBOID_COLOR } from '../cuboids/constants';

const generateStyle = (color: number) => ({
  style: {
    variant: CuboidVariants.LinesAndTransparentMesh,
    fillColor: color,
    fillOpacity: 0.1,
    lineColor: color,
    lineWidth: 2,
    lineOpacity: 0.8,
  },
  hoveredStyle: {
    variant: CuboidVariants.LinesAndTransparentMesh,
    fillColor: color,
    fillOpacity: 0.4,
    lineColor: color,
    lineWidth: 2,
    lineOpacity: 1,
  },
});

export const TOTAL_AREA_FIELD_FORMATTER: Record<string, string> = {
  area: 'Area',
  light: 'Light',
  moderate: 'Moderate',
  heavy: 'Heavy',
  ri0: 'Ri0',
  ri1: 'Ri1',
  ri2: 'Ri2',
  ri3: 'Ri3',
  ri4: 'Ri4',
  ri5: 'Ri5',
  totalCorrodedArea: 'Total Corroded Area',
  ri4plusri5: 'Ri4+Ri5',
  blister: 'Blister',
  cups: 'Cups',
  hotbolting: 'Hotbolting',
  other: 'Other',
  paintDamage: 'Paint Damage',
};

export const CUSTOM_BLOCK_CUBOID_STYLES = {
  yellow: generateStyle(DEFAULT_CUBOID_COLOR),
  green: generateStyle(0x22C55E),
  blue: generateStyle(0x76CAFF),
  white: generateStyle(0xffffff),
};
